document.addEventListener("DOMContentLoaded", () => {
  const images = document.querySelectorAll(".move-in-on-scroll");
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: ".move-in-on-scroll", // the parent or container might work better here
      start: "top 80%",
      toggleActions: "play none none none",
    },
  });
  tl.to(images, {
    duration: 2, // Longer duration for smoother movement
    opacity: 1,
    x: 0,
    y: 0,
    ease: "power4.out", // softer easing for smoother effect
    stagger: 0.25, // slight, clear delays between images
  });
});
